export default __webpack_public_path__ + "static/media/Bloodtainted Band.b1c04485.jpg";